
export const NEW_UNIDADE_MEDIDA_CONVERSAO_CADASTRO = 'NEW_UNIDADE_MEDIDA_CONVERSAO_CADASTRO'
export const NEW_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS = 'NEW_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS'

export const CREATE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO = 'CREATE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO'
export const CREATE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING = 'CREATE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING'
export const CREATE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS = 'CREATE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS'
export const CREATE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE = 'CREATE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE'

export const CANCEL_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_RAPIDO = 'CANCEL_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_RAPIDO'
export const CANCEL_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_RAPIDO_SUCCESS = 'CANCEL_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_RAPIDO_SUCCESS'

export const TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO = 'TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO'
export const TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING = 'TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING'
export const TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS = 'TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS'
export const TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE = 'TABLE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE'

export const LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO = 'LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO'
export const LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING = 'LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING'
export const LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS = 'LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS'
export const LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE = 'LIST_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE'

export const FIND_UNIDADE_MEDIDA_CONVERSAO_CADASTRO = 'FIND_UNIDADE_MEDIDA_CONVERSAO_CADASTRO'
export const FIND_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING = 'FIND_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING'
export const FIND_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS = 'FIND_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS'
export const FIND_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE = 'FIND_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE'

export const DELETE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO = 'DELETE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO'
export const DELETE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING = 'DELETE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_PENDING'
export const DELETE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS = 'DELETE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_SUCCESS'
export const DELETE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE = 'DELETE_UNIDADE_MEDIDA_CONVERSAO_CADASTRO_FAILURE'
